import React from 'react';
import BucketRaceSummary from './BucketRaceSummary';

export default function BucketNextUp() {
  return <div className="sr-page bucket-workspace">
    <h1>Bucket Next Up</h1>
    <BucketRaceSummary nextUp />
  </div>;
}
